import { Box, Text } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

export const RibbonWrapper = Box.withConfig({
  zIndex: Styles.zIndex.max,
});

export const RibbonContent = Box.withConfig({
  zIndex: Styles.zIndex.normal,
  backgroundColor: primitive.bk.$meltyYellow,
});

export const StyledRibbon = Text.withConfig({
  fontFamily: 'Flame-Regular',
  fontSize: 'xs',
  color: primitive.bk.$bbqBrown,
  lineHeight: 'xs',
  textAlign: 'center',
  paddingX: '$3',
  zIndex: Styles.zIndex.max,
  paddingTop: '$0.5',
  paddingBottom: '$0.5',
  marginBottom: '$1',
});
